import React, { forwardRef } from 'react';

const TextFieldSm = forwardRef(({ name, value, error, label, disabled, placeholder, type = "text", ...rest }, ref) => {
    return (
        <>
            {!!label ? <label>{label}</label> : null}
            <input
                className='input-size-sm'
                placeholder={placeholder ?? ""}
                type={type}
                name={name}
                value={value}
                disabled={disabled}
                ref={ref}
                {...rest}
            />
            {error ? <p style={{ color: "red" }}>{error}</p> : null}
        </>
    );
});

export default TextFieldSm;
